<template>
  <div class="footer-page-view flex-middle-x layout-flex-justify-content_space-between">
    <div class="footer-page-box">
      <ul class="flex-x layout-flex-justify-content_space-between">
        <li class="contact">
          <h4>CONTACT</h4>
          <h5>READ MORE</h5>
          <h4>021-61921322</h4>
        </li>
        <li class="about-us-content">
          <h6>关于我们 ABOUT  US</h6>
          <p v-for="(item,index) in navTabList"
             @click="actionClickNavTab(index)"
          >{{item.title}}</p>
        </li>
        <li class="about-us">
          <h6>关于我们 ABOUT  US</h6>
          <p>上海金保证网络科技有限公司</p>
          <p>地      址：上海闵行区宜山路1618号新意城C栋308</p>
          <p>电      话：021-61921322</p>
          <p>客服热线：021-61921322</p>
          <p>邮      箱：pengdashuai@jinbaozheng.com</p>
        </li>
      </ul>
      <div class="tcp-view-footer">
        <div class="tcp-view-box">
          <h6><a href="http://beian.miit.gov.cn">沪ICP备17030686号copyright© 2012-2026上海金保证网络科技有限公司版权所有</a></h6>
          <div class="flex-middle-x layout-flex-center">
            <span>诚信网站</span>
            <img :src="tcpImage" alt="">
            <a  target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011202005757">
              沪公网安备 31011202005757号
            </a>
            <span class="report">网上有害信息举报专区</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name:'',
    data(){
      return {
        tcpImage:require('../image/tcp-image.png')
      }
    },
    computed:{
      navTabList(){
        return [
          {title:'网站首页'},
          {title:'产品信息'},
          {title:'团队介绍'},
          {title:'合作伙伴'},
          {title:'关于我们'}
        ]
      }
    },
    methods:{
      actionClickNavTab(id){
        window.scrollTo(0, 0)
        if (id === 0){
          this.$router.push({name:'ComputerHomePage'});
        } else if (id === 1){
          this.$router.push({name:'ProductInformationPage'});
        } else if (id === 2){
          this.$router.push({name:'TeamIntroductionPage'});
        } else if (id === 3){
          this.$router.push({name:'PartnerPageView'});
        } else if (id === 4){
          this.$router.push({name:'AboutUsPage'});
        }
      }
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss" scoped="">
  .footer-page-view{
    color:$color-4;
    background:#252525;
    .footer-page-box{
      width:100%;
      ul{
        max-width:1200px;
        text-align: left;
        margin:auto;
        padding-bottom:30px;
        .contact{
          padding-right:200px;
          h4{
            font-size:36px;
            margin-top:20px;
          }
          h5{
            font-size:18px;
            border-bottom:1px solid $color-4;
            padding:10px 0;
          }
        }
        .about-us-content{
          padding-right:100px;
          h6{
            font-size:16px;
            border-bottom:1px solid $color-4;
            margin-top:20px;
            padding:10px 0;
            cursor: pointer;
            &:hover{
              color:$color-4;
            }
          }
          p{
            font-size:14px;
            color:#626262;
            margin-top:10px;
            cursor: pointer;
            &:hover{
              color:$color-4;
            }
          }
        }
        .about-us{
          padding-right:100px;
          h6{
            font-size:16px;
            border-bottom:1px solid $color-4;
            margin-top:20px;
            padding:10px 0;
          }
          p{
            font-size:14px;
            color:#626262;
            margin-top:10px;
          }
        }
      }
      .tcp-view-footer{
        width:100%;
        border-top:1px solid #393939;
        background:#262626;
        padding-bottom:30px;
        .tcp-view-box{
          text-align: center;
          padding:20px 0 0 0;
          color:#a6a6a6;
          h6{
            font-size:14px;
            a{
              color:$color-4;
            }
          }
          div{
            margin-top:20px;
            img{
              width:15px;
              padding:0 20px 0 40px;
            }
            a{
              font-size:13px;
              padding-right:50px;
              border-right:1px solid #aeaeae;
              color:#a6a6a6;
            }
            span{
              font-size:13px;
              padding-right:50px;
              border-right:1px solid #aeaeae;
            }
            .report{
              padding-left:50px;
              border:none;
            }
          }
        }
      }
    }
  }
</style>
